import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function imgUrl(imageId, variant = "medium") {
  if (!imageId) return null;
  return `${API}/images/${imageId}/${variant}`;
}

export function formatPrice(v) {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(v);
}

export function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function errText(e) {
  const status = e?.response?.status;
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && !/error|exception|traceback|cloudflare|gateway/i.test(d)) return d;
  if (Array.isArray(d)) return "Bitte überprüfe deine Eingaben.";
  const map = {
    401: "Bitte melde dich erneut an.",
    403: "Du hast keine Berechtigung für diese Aktion.",
    404: "Dieser Inhalt wurde nicht gefunden.",
    409: "Diese Aktion ist aktuell nicht möglich.",
    429: "Zu viele Anfragen. Bitte warte einen Moment.",
    500: "Momentan gibt es ein technisches Problem.",
    502: "KLEDIO ist gerade kurz nicht erreichbar. Bitte versuche es gleich noch einmal.",
    503: "KLEDIO ist momentan nicht verfügbar.",
    504: "Die Anfrage dauert zu lange. Bitte versuche es erneut.",
  };
  if (status && map[status]) {
    const rid = `RV-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
    console.error(`[KLEDIO ${rid}]`, status, e?.config?.url, e?.message);
    return status >= 500 ? `${map[status]} (Fehler-ID: ${rid})` : map[status];
  }
  if (e?.code === "ERR_NETWORK" || !e?.response) {
    console.error("[KLEDIO network]", e?.message);
    return "Keine Verbindung — wir konnten KLEDIO gerade nicht erreichen. Bitte versuche es erneut.";
  }
  return "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
}

let _feesPromise = null;
export function getFees() {
  if (!_feesPromise) _feesPromise = api.get("/fees").then(({ data }) => data).catch(() => null);
  return _feesPromise;
}

export function withProtection(price, fees) {
  if (!fees) return null;
  return Math.round((price + price * fees.buyer_fee_percent / 100 + fees.buyer_fee_fixed) * 100) / 100;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 3600) return `vor ${Math.max(1, Math.floor(s / 60))} Min.`;
  if (s < 86400) return `vor ${Math.floor(s / 3600)} Std.`;
  if (s < 2592000) return `vor ${Math.max(1, Math.floor(s / 86400))} Tagen`;
  if (s < 31536000) return `vor ${Math.max(1, Math.floor(s / 2592000))} Monaten`;
  return `vor ${Math.floor(s / 31536000)} Jahren`;
}

let _adQueue = [];
let _adTimer = null;
const _adSeen = new Set();
export function trackAd(itemId, type) {
  const key = `${type}:${itemId}`;
  if (type === "impression" && _adSeen.has(key)) return;
  _adSeen.add(key);
  _adQueue.push({ item_id: itemId, type });
  if (!_adTimer) {
    _adTimer = setTimeout(() => {
      const events = _adQueue.splice(0, 50);
      _adTimer = null;
      if (events.length) api.post("/ads/track", { events }).catch(() => {});
    }, 2500);
  }
}

export const CONDITIONS = {
  NEU: "Neu",
  NEU_MIT_ETIKETT: "Neu mit Etikett",
  SEHR_GUT: "Sehr gut",
  GUT: "Gut",
  AKZEPTABEL: "Akzeptabel",
};

export const ORDER_STATUS = {
  PENDING_PAYMENT: "Zahlung ausstehend",
  PAID: "Bezahlt",
  SHIPPED: "Versendet",
  DELIVERED: "Zugestellt",
  COMPLETED: "Abgeschlossen",
  CANCELLED: "Abgebrochen",
  REFUNDED: "Erstattet",
};

export const PAYOUT_STATUS = {
  PENDING: "Ausstehend",
  HELD: "Käuferschutz aktiv",
  ELIGIBLE: "Freigegeben",
  PAYOUT_PENDING: "Auszahlung wartet (KYC)",
  PAYOUT_CREATED: "Auszahlung erstellt",
  PAYOUT_COMPLETED: "Ausgezahlt",
  PAYOUT_FAILED: "Auszahlung fehlgeschlagen",
  REFUNDED: "Erstattet",
  DISPUTED: "Fall offen",
};
